export default {
  name: 'Hoverable',
  data() {
    return {
      isHover: false,
      hoverHandlers: {
        mouseenter: this.onMouseEnter,
        mouseleave: this.onMouseLeave,
      },
    };
  },
  methods: {
    onMouseEnter() {
      this.isHover = true;
    },
    onMouseLeave() {
      this.isHover = false;
    },
  },
};
